export enum InteractiveCardType {
  ACTION = 'action',
  QUESTION = 'question',
  PICTURE = 'picture',
  COURSE = 'course'
}